<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.plannedCourses') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="plannedCoursesTable.additionalFilters"
									:default-sort="plannedCoursesTable.defaultSort"
									:excel="true"
									:fields="plannedCoursesTable.headers"
									:header-selection-key="'planned-courses-headers'"
									:height="plannedCoursesTable.height"
									:total-records="plannedCoursesTable.total"
									:filter-save-key="'planned-courses-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in plannedCoursesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td>
											<v-tooltip bottom v-if="item.language_id == 2 || item.language_id == 3">
												<template v-slot:activator="{ on, attrs }">
													<v-icon
														v-bind="attrs"
														v-on="on"
														size="x-small"
														:color="item.language_id == 2 ? 'blue' : 'purple'"
														>fa fa-circle</v-icon
													>&nbsp;
												</template>
												<span>{{
													item.language_id == 2
														? $t('tooltips.courseOnEnglish')
														: $t('tooltips.courseOnHungarian')
												}}</span>
											</v-tooltip>
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('office_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.office.name }}</b>
										</td>
										<td
											v-if="
												plannedCoursesTable.selectedHeaders.includes('planned_course_status_id')
											"
											@click="editClick(item.id, false)"
										>
											<v-chip
												v-if="item.planned_course_status_id == 1"
												class="text-uppercase pl-4"
												text-color="#6F6F6F"
												color="#6F6F6F40"
												><v-icon x-small left color="#6F6F6F"> fas fa-circle </v-icon>
												{{ item.planned_course_status.name }}
											</v-chip>
											<v-chip
												v-if="item.planned_course_status_id == 2"
												class="text-uppercase pl-4"
												text-color="#BBBB00"
												color="#E1E10040"
												><v-icon x-small left color="#BBBB00"> fas fa-circle </v-icon>
												{{ item.planned_course_status.name }}
											</v-chip>
											<v-chip
												v-if="item.planned_course_status_id == 3"
												class="text-uppercase pl-4"
												text-color="#008000"
												color="#00800040"
												><v-icon x-small left color="#008000"> fas fa-circle </v-icon>
												{{ item.planned_course_status.name }}
											</v-chip>
											<v-chip
												v-if="item.planned_course_status_id == 4"
												class="text-uppercase pl-4"
												text-color="#FF0000"
												color="#FF000040"
											>
												<v-icon x-small left color="#FF0000"> fas fa-circle </v-icon>
												{{ item.planned_course_status.name }}
											</v-chip>
											<v-chip
												v-if="item.planned_course_status_id == 5"
												class="text-uppercase pl-4"
												text-color="#4360DF"
												color="#4360DF40"
												><v-icon x-small left color="#4360DF"> fas fa-circle </v-icon>
												{{ item.planned_course_status.name }}
											</v-chip>
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('course_code')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.course.code }}</b>
										</td>
										<td
											class="truncate-course-name"
											v-if="plannedCoursesTable.selectedHeaders.includes('course_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.course.name }}</b>
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('code')"
											@click="editClick(item.id, false)"
										>
											{{ item.code }}
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('start_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.start_date != null
													? item.start_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('end_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.end_date != null
													? item.end_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											style="text-align: right"
											v-if="plannedCoursesTable.selectedHeaders.includes('registration')"
											@click="editClick(item.id, false)"
										>
											{{ item.registration }}
										</td>
										<td
											style="text-align: right"
											v-if="plannedCoursesTable.selectedHeaders.includes('preregistration')"
											@click="editClick(item.id, false)"
										>
											{{ item.preregistration }}
										</td>
										<td
											v-if="plannedCoursesTable.selectedHeaders.includes('department_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.department.name }}
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'PlannedCourses',
	components: { TheTable },
	data: function () {
		return {
			plannedCoursesTable: {
				selectedHeaders: [],
				headers: [
					{ text: '', value: 'actions2', type: '', sortable: false, width: '50px', allowFilter: false },
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.office'), value: 'office_id', type: 'dropdown|offices', allowFilter: true },
					{
						text: this.$t('fields.status'),
						value: 'planned_course_status_id',
						type: 'multiple|planned-course-statuses-filter',
						allowFilter: true,
					},

					{
						text: this.$t('fields.courseCode'),
						value: 'course_code',
						type: 'dropdown|courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.courseName'),
						value: 'course_name',
						type: 'dropdown|courses',
						allowFilter: true,
					},
					{ text: this.$t('fields.courseNumber'), value: 'code', type: 'string', allowFilter: true },
					{ text: this.$t('fields.startDate'), value: 'start_date', type: '', allowFilter: true },
					{ text: this.$t('fields.endDate'), value: 'end_date', type: '', allowFilter: true },
					{
						text: this.$t('fields.registration'),
						value: 'registration',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.preregistration'),
						value: 'preregistration',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.department'),
						value: 'department_id',
						type: 'dropdown|departments',
						allowFilter: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.registration'), value: 'registration', type: 'number_range' },
					{ text: this.$t('fields.preregistration'), value: 'preregistration', type: 'number_range' },
					{ text: this.$t('fields.language'), value: 'language_id', type: 'dropdown|languages' },
					{ text: this.$t('fields.startDate'), value: 'start_date', type: 'date_range' },
					{ text: this.$t('fields.endDate'), value: 'end_date', type: 'date_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/planned-courses/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/planned-courses/' + id);
			} else {
				let routeData = this.$router.resolve('/planned-courses/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.plannedCoursesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.plannedCoursesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'planned-courses',
				request,
				(data, success) => {
					if (success) {
						vm.plannedCoursesTable.items = data.items;
						vm.plannedCoursesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.plannedCoursesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'planned-courses',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/planned-courses', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.plannedCoursesTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.plannedCourses'), href: '/#/planned-courses', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped>
.truncate-course-name {
	max-width: 600px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
